export default __webpack_public_path__ + "static/media/upliftsales.a2aa2586.jpg";